import * as React from "react";
import Box from "@mui/material/Box";
import Avatar from "./Avatar";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useState } from "react";
import EditProfileInput from "./EditProfileInput";
import { makeStyles } from "@mui/styles";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const useStyles = makeStyles((theme) => ({
  editProfileButton: {
    backgroundColor: theme.palette.common.blue,
    "&:hover": {
      backgroundColor: theme.palette.common.blue,
    },
  },
}));

const theme = createTheme();

function ProfileCard(props) {
  const classes = useStyles();
  const avatarDetails = {
    width: 80,
    height: 80,
  };
  const [isClicked, setIsClicked] = useState(false);
  const buttonClickHandler = (e) => {
    setIsClicked((currentIsClicked) => !currentIsClicked);
  };

  return isClicked ? (
    <EditProfileInput details={avatarDetails} />
  ) : (
    <ThemeProvider theme={theme}>
      <Box sx={{ minWidth: 275 }}>
        <Card variant="outlined" sx={{ minWidth: 275 }}>
          <CardContent>
            <Avatar details={avatarDetails} />
            <Typography variant="h5" component="div">
              {props.details.user.username}
            </Typography>
            <Typography sx={{ mb: 1.5 }} color="black">
              {props.details.user.first_name} {props.details.user.last_name}
            </Typography>
            <Typography variant="h5" component="div">
              {props.details.course}
            </Typography>
            <Typography variant="h5" component="div">
              {props.details.cohort}
            </Typography>
            <Typography variant="body2" component="div">
              {props.details.bio}
            </Typography>
          </CardContent>
          <Button
            onclick={buttonClickHandler}
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            classes={classes.editProfileButton}
          >
            Edit profile
          </Button>
        </Card>
      </Box>
    </ThemeProvider>
  );
}

export default ProfileCard;
